import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { ArrowLeft, Loader2, AlertTriangle } from 'lucide-react';
import { PageContentWrapper } from '../main/LayoutStyles';
import { FullArticleWrapper, ReadMoreButton } from './KnowledgeStyles';
import { AlertBox } from '../main/CommonStyles';
import apiClient from '../services/api';
import { useTheme } from 'styled-components'; // POPRAWKA

const FullArticleView = () => {
    const { slug } = useParams();
    const navigate = useNavigate();
    const [article, setArticle] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const theme = useTheme(); // POPRAWKA

    useEffect(() => {
        const fetchArticle = async () => {
            setLoading(true);
            setError('');
            try {
                const response = await apiClient.get(`/articles/${slug}`);
                setArticle(response.data);
            } catch (err) {
                setError(err.response?.data?.message || 'Nie udało się załadować artykułu.');
                console.error("Błąd ładowania artykułu:", err);
            } finally {
                setLoading(false);
            }
        };

        if (slug) {
            fetchArticle();
        }
    }, [slug]);

    if (loading) {
        return (
            <PageContentWrapper style={{ textAlign: 'center', paddingTop: '50px' }}>
                <Loader2 size={48} className="icon-spin" />
                <p>Ładowanie artykułu...</p>
            </PageContentWrapper>
        );
    }

    if (error) {
        return (
            <PageContentWrapper>
                <AlertBox type="error">
                    <AlertTriangle />
                    {error}
                </AlertBox>
                <ReadMoreButton onClick={() => navigate(-1)}>
                    <ArrowLeft size={16} /> Powrót
                </ReadMoreButton>
            </PageContentWrapper>
        );
    }

    if (!article) {
        return (
            <PageContentWrapper>
                <p>Nie znaleziono artykułu.</p>
            </PageContentWrapper>
        );
    }

    return (
        <HelmetProvider>
            <Helmet>
                <title>{`${article.title} - ePsycholog`}</title>
                <meta name="description" content={article.snippet} />
                <meta property="og:title" content={`${article.title} - ePsycholog`} />
                <meta property="og:description" content={article.snippet} />
                {article.imageUrl && <meta property="og:image" content={article.imageUrl} />}
                <meta property="og:type" content="article" />
                <meta property="og:url" content={`https://epsycholog.app/app/knowledge/${article.slug}`} />
            </Helmet>
            <PageContentWrapper className="custom-scrollbar">
                <ReadMoreButton
                    onClick={() => navigate(-1)}
                    style={{ marginBottom: theme.spacing.md, alignSelf: 'flex-start' }}
                    $variant="outline"
                >
                    <ArrowLeft size={16} style={{ marginRight: theme.spacing.xs }} />
                    Powrót
                </ReadMoreButton>
                <FullArticleWrapper>
                    {article.imageUrl && (
                        <img src={article.imageUrl} alt={article.title} className="article-image-full" />
                    )}
                    <div className="article-content" dangerouslySetInnerHTML={{ __html: article.fullContent }} />
                </FullArticleWrapper>
            </PageContentWrapper>
        </HelmetProvider>
    );
};

export default FullArticleView;